import { WORKFLOW_GENERATION } from '../../constants/CopilotInAppActionTypes';
export const workflowGeneration = action => {
  return {
    data: {
      intent: WORKFLOW_GENERATION,
      query: action.query
    }
  };
};